const navLinkStyledLogin = {
  text: 'Forgot password?',
  qrcode: 'Read public data'
};

export default navLinkStyledLogin;
